import React, { useEffect } from 'react';
import { Clock, Disc3, Trash, Music, Play, Pause } from 'lucide-react';
import { ProjectCardProps } from '../../types/project';

export const ProjectCard: React.FC<ProjectCardProps> = ({ project, onDelete, onContinue }) => {
    const [isPlaying, setIsPlaying] = React.useState(false);
    const audioRef = React.useRef<HTMLAudioElement>(null);

    useEffect(() => {
        return () => {
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.src = '';
                audioRef.current = null;
            }
        };
    }, []);

    const isDerivative = project.tags?.includes('derivative');
    const isSoundworld = project.tags?.includes('soundworld');

    const formattedDate = new Date(project.created_at).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });

    const togglePlayback = () => {
        if (audioRef.current) {
            if (isPlaying) {
                audioRef.current.pause();
            } else {
                audioRef.current.play();
            }
            setIsPlaying(!isPlaying);
        }
    };

    const handleAudioEnded = () => {
        setIsPlaying(false);
    };

    return (
        <div className="border h-max border-border rounded-lg p-4 shadow-sm hover:shadow-md transition relative group bg-card">
            <div className="flex items-start justify-between">
                <div>
                    <h3 className="font-semibold text-sm text-card-foreground">{ project.name || 'Untitled Project' }</h3>
                    <p className="text-xs text-muted-foreground">{ project.description || "No description" }</p>
                </div>
                <div className="flex items-center gap-2 text-muted-foreground">
                    <button
                        onClick={ () => onDelete(project.project_id) }
                        className="hover:text-red-500 cursor-pointer"
                    >
                        <Trash size={ 14 } />
                    </button>
                    { isDerivative ? (
                        <Disc3 size={ 16 } color="#0099FF" />
                    ) : isSoundworld ? (
                        <Music size={ 16 } color="#0099FF" />
                    ) : (
                        <Disc3 size={ 16 } color="#0099FF" />
                    ) }
                </div>
            </div>
            <div className="mt-4 flex items-center justify-between">
                <div className="flex items-center text-xs text-muted-foreground gap-1">
                    <Clock size={ 14 } />
                    { formattedDate }
                </div>
                <button
                    onClick={ () => onContinue(project.project_id) }
                    className="btn-primary text-xs px-3 py-1"
                >
                    Continue Editing
                </button>
            </div>
        </div>
    );
};